"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function PlayStartIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "m9.341,19.752c-.205,0-.413-.045-.608-.138-.502-.237-.813-.729-.813-1.285V5.671c0-.555.312-1.047.813-1.285.502-.236,1.08-.164,1.508.188l7.695,6.33c.329.271.518.67.518,1.096s-.188.826-.518,1.097l-7.695,6.329c-.261.215-.578.326-.899.326Zm.277-13.488v11.473l6.975-5.736-6.975-5.737Z" })));
}
exports.default = PlayStartIcon;
